module.exports = __webpack_public_path__ + "fasaw1.png?cf61a489b1c9d4af42f43f9681443bd8";